/**
 * Distances and the visitor's position.
 *
 * Coordinates in the catalogue are approximate to the neighbourhood, so a
 * distance here is an order of magnitude, not a walking figure — which is why
 * it is rounded generously rather than shown to the metre.
 */

const EARTH_RADIUS_KM = 6371;

const toRadians = (degrees) => (degrees * Math.PI) / 180;

export function distanceKm(from, to) {
  const dLat = toRadians(to.lat - from.lat);
  const dLng = toRadians(to.lng - from.lng);
  const lat1 = toRadians(from.lat);
  const lat2 = toRadians(to.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h));
}

/** Metres rounded to 50 below a kilometre, then one decimal up to 10 km. */
export function formatDistance(km) {
  if (km < 1) return `${Math.round((km * 1000) / 50) * 50} m`;
  return `${km.toFixed(km < 10 ? 1 : 0)} km`;
}

/**
 * Resolves to a position and how it was obtained. A refusal or a missing API
 * is never silent: the caller gets no coordinates and a line to show.
 *
 * There used to be a stand-in, the centre of Rome, from when the catalogue was
 * Rome. With venues from the Alps to Sicily, sorting a visitor in Milan by
 * their distance from the Colosseum is not a fallback but a wrong answer, so
 * without a position the lists simply keep their episode order.
 */
export function locate() {
  const fallback = {
    coords: null,
    exact: false,
    label: 'Posizione non disponibile: elenco per puntata',
  };

  if (!navigator.geolocation) return Promise.resolve(fallback);

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) =>
        resolve({
          coords: { lat: position.coords.latitude, lng: position.coords.longitude },
          exact: true,
          label: 'Ordinati per distanza da te',
        }),
      () => resolve(fallback),
      { timeout: 10000 }
    );
  });
}
